import styles from "./newsListItem.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
const NewsListItem = ({ article }) => {
    const navigate = useNavigate();
    const truncateText = (text, title, normalLength = 170, titleLenght = 60, newLenght = 120) => {

        var definitionLenght = normalLength;

        if (title.length > titleLenght) {
            definitionLenght = newLenght;
        }


        // Remove all newlines
        const cleanedText = text.replace(/(\r\n|\n|\r)/g, " ");

        // Limit text to maxLength and add "..." if needed
        if (cleanedText.length > definitionLenght) {
            return cleanedText.slice(0, definitionLenght) + "...";
        }
        return cleanedText;
    };
    function useIsSmallScreen(breakpoint = 800) {
        const [isSmall, setIsSmall] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => {
                setIsSmall(window.innerWidth < breakpoint);
            };
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, [breakpoint]);

        return isSmall;
    }
    const isSmallScreen = useIsSmallScreen(800);
    const isSmallScreen600 = useIsSmallScreen(600);

    const truncatedText = truncateText(
        article.content_text,
        article.title,
        isSmallScreen600 ? 110 : isSmallScreen ? 110 : 170,
        isSmallScreen600 ? 60 : isSmallScreen ? 60 : 80,
        isSmallScreen600 ? 80 : isSmallScreen ? 80 : 120
    );

    return (
        <div tabIndex={0} className={styles.container} onClick={() => navigate(`/news/${article.slug}`)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {

                    e.preventDefault(); // Prevent space from scrolling
                    navigate(`/news/${article.slug}`)
                }
            }}>

            <div className={styles.imageContainer}>
                <img
                    className={styles.image}
                    src={`${process.env.PUBLIC_URL}${article.image}`}
                    alt={article.title}
                />
            </div>
            <div className={styles.textContainer}>
                <div className={styles.text}>
                    <div className={styles.titleSpacer}>
                        <h2 className={styles.title}>{article.title}</h2>
                    </div>
                    <p className={styles.newsText}>{truncatedText}</p>
                </div>
                {!isSmallScreen600 ? (
                    <>
                        <p className={styles.date}>{article.published_date}</p>
                        <p className={styles.author}>
                            {article.concat_categories} | {article.author_name}
                        </p>
                    </>
                ) :
                    (
                        <p className={styles.author}>
                            <span className={styles.categories}>{article.concat_categories}</span> {" "}
                            <span>{article.author_name}</span> |{" "}
                            <span>{article.published_date}</span>
                        </p>
                    )}

            </div>
        </div >
    );
};

export default NewsListItem;
